document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('#mobile-menu-content');
  if (!menu) return;

  const container = menu.querySelector('.container');
  const list = container.querySelector('.mobile-menu-link-list');
  const initialHTML = list.innerHTML;
  const history = [];

  // Header with only back button (no title)
  const header = document.createElement('div');
  header.className = 'mobile-menu-backbar';
  header.innerHTML = `
    <button type="button" class="mobile-menu-back-btn" aria-label="Zurück">← Zurück</button>
  `;
  header.style.display = 'none';
  container.prepend(header);

  const backBtn = header.querySelector('.mobile-menu-back-btn');

  const getDirectSubList = (li) =>
    li ? li.querySelector(':scope > .mobile-menu-sub-link-list') : null;

  // Event delegation
  list.addEventListener('click', (e) => {
    const link = e.target.closest('a.h4');
    if (!link) return;

    const li = link.closest('li');
    const sub = getDirectSubList(li);

    if (!sub) return; // normal navigation

    e.preventDefault();

    // Save current state
    history.push(list.innerHTML);

    // Show submenu
    list.innerHTML = sub.innerHTML;
    header.style.display = 'flex';
  });

  backBtn.addEventListener('click', () => {
    if (history.length === 0) {
      list.innerHTML = initialHTML;
      header.style.display = 'none';
      return;
    }

    const prev = history.pop();
    list.innerHTML = prev;

    if (history.length === 0) {
      header.style.display = 'none';
    }
  });

  // Optional: Escape key = back
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header.style.display !== 'none') {
      backBtn.click();
    }
  });
});
